<script setup lang="ts">
import type { FiscalShiftAction, OrderShiftBlocker } from '@/entities/fiscalization';

import { fiscalShiftActionLabel } from '@/entities/fiscalization';
import { AppButton } from '@/shared/ui';

defineProps<{
  blocker: OrderShiftBlocker;
  pending?: boolean;
}>();

const emit = defineEmits<{
  action: [action: Exclude<FiscalShiftAction, null>];
}>();
</script>

<template>
  <div
    class="rounded-xl border border-(--base-warning-color)/40 bg-(--base-warning-color)/10 p-4"
    role="status"
  >
    <p class="text-sm font-semibold text-pretty text-(--base-text-color)">
      {{ blocker.title }}
    </p>
    <p
      v-if="blocker.hint"
      class="mt-1 text-xs leading-5 text-pretty text-(--base-popup-secondary-color)"
    >
      {{ blocker.hint }}
    </p>
    <AppButton
      v-if="blocker.action"
      class="mt-3 min-h-11 w-full"
      :loading="pending"
      @click="emit('action', blocker.action)"
    >
      {{ fiscalShiftActionLabel[blocker.action] }}
    </AppButton>
  </div>
</template>
